import React, { useState, useEffect, useMemo } from 'react'
import * as yup from 'yup'
import Button from 'components/ui-kit/Button/index'
import { AnimationIcon, CrossIcon, MusicIcon, RightArrowIcon, SoundIcon, TogglerIcon } from 'assets/icons/index'
import SwitchButton from 'components/ui-kit/SwitchButton/index'
import Image from 'components/ui-kit/Image/index'
import { useDispatch, useSelector } from 'react-redux'
import { fetchUserInformation } from 'redux-store/thunk/user.thunk'
import { getPrecision, numberWithCommas } from 'helpers/common.helpers'
import useGameSettingsUpdateSocketNameSpace from 'socket-resources/hooks/useGameSettingsUpdateSocketNameSpace'
import { getAllCurrency, getGameSetting } from 'redux-store/thunk/gameSettings.thunk'
// import { signOut } from 'helpers/cookie.helpers'
import { setGameMusic, setGameSound, updateGameSetting } from 'redux-store/redux/slices/gameSettings.slice'

import { userLogin } from 'redux-store/thunk/auth.thunk'
import { CURRENCIES, DEFAULT_GAME_ID, LANGUAGE, LANGUAGES, ROUTE_PATHS } from 'constants/index'
import { useLocation, useHistory } from 'react-router-dom'
import { openErrorToaster } from 'helpers/toaster.helpers'
import buttonClickSound from './audios/button-click.wav'
import gameMusicSound from './audios/game-music.mp3'
// import coinFlipMusicSound from './audios/coin-flip-music.mp3'
// import minesMusicSound from './audios/mines-music.mp3'
import plinkoMusicSound from './audios/plinko-music.mp3'
import { Howl } from 'howler'
import './Header.scss'
import i18n from 'translation/index'
import { setLocalLanguage } from 'helpers/localstorage.helpers'
import { setDemoMode } from 'redux-store/redux/slices/auth.slice'
import HowToPlay from 'games/CrashGames/GameTheme/FlyCrashGame/components/HowToPlay/index'
import GameLimit from 'games/CrashGames/GameTheme/FlyCrashGame/components/GameLimit/index'
import BetHistoryModal from 'games/CrashGames/GameTheme/FlyCrashGame/components/BetHistoryModal/index'

const NewHeader = () => {
  const showHeader = false // no need to show inside iframe
  const dispatch = useDispatch()
  const { search } = useLocation()
  const history = useHistory()
  const currencyCode = new URLSearchParams(search).get('currencyCode')
  const playerToken = new URLSearchParams(search).get('token')
  const gameId = new URLSearchParams(search).get('gameId')

  const language = new URLSearchParams(search).get('language')
  const demoMode = new URLSearchParams(search).get('demo')

  // // Other iframe attributes receiving in every-matrix
  // const freePlay = new URLSearchParams(search).get('freePlay')
  // const mode = new URLSearchParams(search).get('mode')
  // const mobile = new URLSearchParams(search).get('mobile')
  // const lobbyUrl = new URLSearchParams(search).get('lobbyUrl')
  // const clientId = new URLSearchParams(search).get('clientId')

  const { userInfo, userDetails, isLoggedIn, showName } = useSelector((state) => state.auth)
  const { gameMusic, gameSound, musicVolume } = useSelector((state) => state.gameSetting)
  const listenGameSettingsUpdate = useGameSettingsUpdateSocketNameSpace()
  const [isOpenHistoryModal, setIsOpenHistoryModal] = useState(false)
  const [isOpenGameLimits, setIsOpenGameLimits] = useState(false)
  const [isOpenHowToPlay, setIsOpenHowToPlay] = useState(false)
  const [currentOffset, setCurrentOffset] = useState(0)
  // const [gameId, setGameId] = useState('')

  const displayName = useMemo(() => {
    return userDetails?.firstName || userDetails?.lastName || 'Player'
  }, [userDetails])

  const handleLoginUser = () => {
    const params = {
      payload: {
        operatorId: 1, // TODO: update backend, no need to pass operatorId,
        operatorUserToken: playerToken,
        currencyCode,
        gameId
      },
      history
    }
    dispatch(userLogin(params))
  }

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language || LANGUAGES[0]?.languageCode)
      setLocalLanguage(LANGUAGE, language)
    }
    if (playerToken && currencyCode) {
      handleLoginUser()

      // this allows demo mode if user logs in while selecting the demo option
      demoMode && dispatch(setDemoMode(!!JSON.parse(demoMode)))
    } else if (demoMode) {
      dispatch(setDemoMode(!!JSON.parse(demoMode)))
    } else {
      history.push(ROUTE_PATHS.home)
    }
  }, [playerToken, currencyCode, demoMode])

  useEffect(() => {
    dispatch(getAllCurrency())
    dispatch(getGameSetting())
    window.addEventListener('beforeunload', () => {
      // signOut()
    })
    const clearGameSettingsUpdate = listenGameSettingsUpdate(handleGameSettingsUpdate)

    return () => {
      clearGameSettingsUpdate()
    }
  }, [])

  const buttonClickAudio = useMemo(() => {
    const audio = new Howl({
      src: [buttonClickSound]
    })
    return audio
  }, [])

  const playClickSound = () => {
    if (gameSound) {
      buttonClickAudio?.play()
    }
  }

  const systemGameDataSchemas = yup.array().of(yup.object().shape({
    id: yup.string().required(),
    gameId: yup.number().required(),
    maxBet: yup.object().shape({
      GC: yup.string(),
      SC: yup.string()
    }),
    minBet: yup.object().shape({
      GC: yup.string(),
      SC: yup.string()
    }),
    maxProfit: yup.object().shape({
      GC: yup.string(),
      SC: yup.string()
    }),
    houseEdge: yup.number().required(),
    minOdds: yup.number().required(),
    maxOdds: yup.number().required(),
    minAutoRate: yup.number().required(),
    createdAt: yup.string().required(),
    updatedAt: yup.string().required()
  })).min(1)

  useEffect(() => {
    if (isLoggedIn && !userInfo) {
      dispatch(fetchUserInformation())
    }
  }, [isLoggedIn, userInfo])

  const handleGameSettingsUpdate = async ({ data }) => {
    if (data) {
      const isValid = await systemGameDataSchemas.isValid(data)
      if (isValid) {
        dispatch(updateGameSetting(data))
      }
    }
  }

  const handleGameMusic = useMemo(() => {
    const audio = new Howl({
      src: [gameMusicSound],
      loop: true,
      volume: 0
    })
    return audio
  }, [])

  // const handleCoinFlipMusic = useMemo(() => {
  //   const audio = new Howl({
  //     src: [coinFlipMusicSound],
  //     loop: true,
  //     volume: 0.1
  //   })
  //   return audio
  // }, [])

  // const handleMinesMusic = useMemo(() => {
  //   const audio = new Howl({
  //     src: [minesMusicSound],
  //     loop: true,
  //     volume: 0.1
  //   })
  //   return audio
  // }, [])

  // const handlePlinkoMusic = useMemo(() => {
  //   const audio = new Howl({
  //     src: [plinkoMusicSound],
  //     loop: true,
  //     volume: 0.1
  //   })
  //   return audio
  // }, [])

  useEffect(() => {
    if (+gameId === +DEFAULT_GAME_ID.CRASH) return
    else if (+gameId === +DEFAULT_GAME_ID.TOWER) return
    else if (+gameId === +DEFAULT_GAME_ID.CROSS) return
    else if (+gameId === +DEFAULT_GAME_ID.DICE) return
    else if (+gameId === +DEFAULT_GAME_ID.HILO) return
    else if (+gameId === +DEFAULT_GAME_ID.KENO) return
    else if (+gameId === +DEFAULT_GAME_ID.COIN_FLIP) return
    else if (+gameId === +DEFAULT_GAME_ID.GONGA_MINE) return
    else if (+gameId === +DEFAULT_GAME_ID.PYRAMID_PLINKO) return

    gameMusic
      ? handleGameMusic?.play()
      : handleGameMusic?.pause()
  }, [gameMusic])

  const handleOpen = () => {
    playClickSound()
  }

  const handleBetHistoryOpen = () => {
    setCurrentOffset(0)
    setIsOpenHistoryModal(true)
  }
  const closeDropdown = () => {
    const dropdownButton = document.getElementById('dropdownMenuButton1')
    if (dropdownButton) {
      dropdownButton.click() // Simulate a click on the dropdown button to close it
    }
  }
  const openExternalLink = (url = '') => {
    // window.parent.location = url
  }
  const handleSwitch = () => {
    openErrorToaster({ message: 'Switch Currency in DDD Lobby!' })
  }

  return (
    <>
      {showHeader && (
        <header className=''>
          <nav className='navbar navbar-expand navbar-dark'>
            <div className='container-fluid'>
              <span onClick={() => openExternalLink()} className='navbar-brand p-0 me-0 me-md-4'>
                <Image src='/assets/images/logo/logo.png' alt='logo' />
              </span>
              <div className='justify-content-end flex-grow-1' id='navbarScroll'>
                <ul className='navbar-nav flex-row my-2 my-lg-0 navbar-nav-scroll gap-2'>
                  <li className='nav-item ms-auto'>
                    <Button className='btn-static text-white navbar-wallet-btn d-flex justify-content-end align-items-center py-1 ps-2'>
                      <div className='d-flex'>
                        {userInfo?.wallet?.currency} {numberWithCommas(getPrecision(userInfo?.wallet?.balance, CURRENCIES[userInfo?.wallet?.currency]?.precision || 2))}
                      </div>
                      <SwitchButton
                        className='d-none custom-switch ms-2' onClick={handleSwitch}
                      />
                    </Button>
                  </li>
                  <li className='d-none   nav-item dropdown setting-dropdown'>
                    <span type='button' id='dropdownMenuButton1' data-bs-toggle='dropdown' data-bs-auto-close='outside' aria-expanded='false'>
                      <Button className='btn-outline-secondary' onClick={() => playClickSound()}>
                        <TogglerIcon className='align-baseline' />
                      </Button>
                    </span>
                    <ul className='dropdown-menu dropdown-menu-end mt-3 pb-0' aria-labelledby='dropdownMenuButton1'>
                      <li>
                        <div className='d-flex justify-content-between mb-3'>
                          <div className='d-flex align-items-center gap-3'>
                            <span className='setting-user-icon'>{displayName ? displayName.substring(0, 1) : 'P'}</span>
                            {
                              showName && (
                                <span className='setting-user-name text-white'>{displayName || 'Player'}</span>
                              )
                            }
                          </div>
                          <div>
                            <Button className='btn-outline-primary btn-close-modal p-0 w-26' onClick={closeDropdown}>
                              <CrossIcon />
                            </Button>
                          </div>
                        </div>
                        <ul className='switch-settings text-white'>
                          <li>
                            <div className='dropdown-item d-flex justify-content-between'>
                              <span><AnimationIcon className='me-2' />
                                Animation
                              </span>
                              <div className='form-check form-switch'>
                                <input className='form-check-input ms-1' type='checkbox' role='switch' id='settingCheck1' defaultChecked />
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className='dropdown-item d-flex justify-content-between'>
                              <span><SoundIcon className='me-2' />
                                Sound
                              </span>
                              <div className='form-check form-switch'>
                                <input className='form-check-input ms-1' type='checkbox' role='switch' id='settingCheck2' checked={gameSound} onChange={() => dispatch(setGameSound())} />
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className='dropdown-item d-flex justify-content-between'>
                              <span><MusicIcon className='me-2' />
                                Music
                              </span>
                              <div className='form-check form-switch'>
                                <input className='form-check-input ms-1' type='checkbox' role='switch' id='settingCheck3' checked={gameMusic} onChange={() => dispatch(setGameMusic())} />
                              </div>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li className='d-md-none'><button className='dropdown-item d-flex align-items-center justify-content-between' type='button' onClick={handleOpen}>Choose Character <RightArrowIcon /></button></li>
                      <li className='d-md-none'><button className='dropdown-item d-flex align-items-center justify-content-between' type='button' onClick={() => setIsOpenHowToPlay(true)}>How to play? <RightArrowIcon /></button></li>
                      <li><button className='dropdown-item d-flex align-items-center justify-content-between' type='button' onClick={handleBetHistoryOpen}>Bet History <RightArrowIcon /></button></li>
                      <li><button className='dropdown-item d-flex align-items-center justify-content-between' type='button' onClick={() => openExternalLink()}>DDD Lobby! <RightArrowIcon /></button></li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </header>
      )}

      <HowToPlay
        setIsOpenHowToPlay={setIsOpenHowToPlay}
        isOpenHowToPlay={isOpenHowToPlay}
      />
      <BetHistoryModal
        setIsOpenHistoryModal={setIsOpenHistoryModal}
        isOpenHistoryModal={isOpenHistoryModal}
        currentOffset={currentOffset}
        setCurrentOffset={setCurrentOffset}
      />
      <GameLimit
        setIsOpenGameLimits={setIsOpenGameLimits}
        isOpenGameLimits={isOpenGameLimits}
      />
    </>
  )
}

export default NewHeader
